var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgJoystick = function SvgJoystick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "joystick_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8632",
    d: "M10.192 0a.24.24 0 00-.234.246A1.493 1.493 0 019.276 1.4a2.136 2.136 0 00-.913 1.72.249.249 0 00.243.245h.005a.24.24 0 00.234-.247A1.668 1.668 0 019.6 1.773a1.948 1.948 0 00.839-1.528A.247.247 0 0010.2 0z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "joystick_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8634",
    d: "M1 4.691l-.177.441a17.7 17.7 0 00-.719 7.287 1.687 1.687 0 001.234 1.624 1.6 1.6 0 001.829-.8c.254-.4 1.166-1.707 2.059-3.134a1.915 1.915 0 00.917.237 1.959 1.959 0 001.527-.643c.329-.322.587-.644 1.1-.643a.42.42 0 01.15 0c1.028 0 1.055 1.3 2.652 1.3a1.893 1.893 0 00.682-.124c.907 1.389 1.812 2.649 2.061 3.035a1.627 1.627 0 003.052-.818 17.842 17.842 0 00-.891-7.286l.005.005-.106-.252a3.076 3.076 0 00-2.931-2.277L3.84 2.616A2.981 2.981 0 001 4.691",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "joystick_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1364",
    d: "M0 0h17.436v14.117H0z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "joystick_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8636",
    d: "M13.314 6.47a.683.683 0 10.82.487.681.681 0 00-.652-.509.646.646 0 00-.168.022",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "joystick_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8637",
    d: "M13.288 3.919a.669.669 0 10.169-.022.665.665 0 00-.169.022",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "joystick_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8638",
    d: "M12.052 5.192a.669.669 0 10.168-.022.646.646 0 00-.168.022",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "joystick_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8639",
    d: "M14.548 5.2a.669.669 0 10.169-.022.654.654 0 00-.169.022",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "joystick_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8641",
    d: "M10.155 8.36v.019a1.19 1.19 0 001.171 1.188A1.153 1.153 0 0012.473 8.4v-.013A1.189 1.189 0 0011.3 7.2a1.154 1.154 0 00-1.145 1.16m-5.182-.014v.019a1.189 1.189 0 001.17 1.188A1.156 1.156 0 007.3 8.4v-.024a1.188 1.188 0 00-1.177-1.192 1.158 1.158 0 00-1.15 1.162M9.2 6.741a.267.267 0 00.263.267h.829a.26.26 0 00.258-.262.267.267 0 00-.266-.267h-.829a.259.259 0 00-.258.262m-1.9-.27a.261.261 0 00-.254.266A.266.266 0 007.3 7h.829a.262.262 0 00.255-.267.267.267 0 00-.264-.266h-.829m-3.433-.15l-.317.267a.165.165 0 00-.062.132l.008.922c0 .1.117.2.26.2h.634a.229.229 0 00.258-.2l-.008-.922a.173.173 0 00-.065-.129l-.32-.274a.314.314 0 00-.193-.065.321.321 0 00-.195.066m1-1.013l-.264.323a.336.336 0 000 .4l.271.324a.166.166 0 00.123.07h.9c.1 0 .189-.117.188-.263v-.647a.24.24 0 00-.192-.259l-.9-.007a.163.163 0 00-.125.064M2.2 5.187c-.106 0-.19.114-.188.258l.005.648a.241.241 0 00.192.259h.9a.163.163 0 00.125-.064l.266-.312a.333.333 0 000-.4l-.277-.328a.168.168 0 00-.123-.063zm1.252-1.228l.008.922a.175.175 0 00.065.129l.327.273a.317.317 0 00.388 0l.314-.273a.166.166 0 00.063-.127L4.6 3.961c0-.1-.118-.195-.26-.195h-.666a.229.229 0 00-.226.2",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "joystick_svg__a",
    x1: -1.411,
    y1: 2.867,
    x2: -1.207,
    y2: 2.867,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#597b91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32597e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "joystick_svg__d",
    x1: 0.226,
    y1: 0.719,
    x2: 0.258,
    y2: 0.719,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3b47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b252e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "joystick_svg__g",
    x1: -6.976,
    y1: 4.437,
    x2: -6.422,
    y2: 4.437,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18afff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0062df"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "joystick_svg__i",
    x1: -6.966,
    y1: 5.877,
    x2: -6.411,
    y2: 5.877,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eda83a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdc5e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "joystick_svg__k",
    x1: -6.28,
    y1: 5.159,
    x2: -5.726,
    y2: 5.159,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e61739"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "joystick_svg__m",
    x1: -7.66,
    y1: 5.154,
    x2: -7.106,
    y2: 5.154,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16992b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b31a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "joystick_svg__o",
    x1: 0.078,
    y1: 1.064,
    x2: 0.136,
    y2: 1.064,
    xlinkHref: "#joystick_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5857"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5858"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5857",
    transform: "translate(0 2)",
    clipPath: "url(#joystick_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8631",
    d: "M8.9-.943L6.941 2.495 9.9 4.309 11.861.872z",
    fill: "url(#joystick_svg__a)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5860"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5859",
    transform: "translate(0 2)",
    clipPath: "url(#joystick_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8633",
    d: "M-7.2 9.938L10.911 21.3l13.7-14.268L6.507-4.33z",
    fill: "url(#joystick_svg__d)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5862"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5861",
    transform: "translate(0 2)",
    clipPath: "url(#joystick_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8635",
    d: "M15.938 5.836a2.5 2.5 0 01-2.446 2.554h-.035a2.571 2.571 0 01-2.531-2.567 2.5 2.5 0 012.447-2.553h.036a2.572 2.572 0 012.531 2.567zM4.023 3.243a2.5 2.5 0 00-2.482 2.518V5.8a2.572 2.572 0 002.53 2.568 2.5 2.5 0 002.483-2.521v-.036a2.57 2.57 0 00-2.53-2.568",
    fill: "#132028"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5864"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5863",
    transform: "translate(0 2)",
    clipPath: "url(#joystick_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1365",
    transform: "rotate(-15.009 31.037 -43.755)",
    d: "M0 0h1.805v1.772H0z",
    fill: "url(#joystick_svg__g)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5866"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5865",
    transform: "translate(0 2)",
    clipPath: "url(#joystick_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1366",
    transform: "rotate(-14.98 21.32 -44.942)",
    d: "M0 0h1.804v1.772H0z",
    fill: "url(#joystick_svg__i)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5868"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5867",
    transform: "translate(0 2)",
    clipPath: "url(#joystick_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1367",
    transform: "rotate(-15.009 25.556 -39.607)",
    d: "M0 0h1.804v1.772H0z",
    fill: "url(#joystick_svg__k)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5870"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5869",
    transform: "translate(0 2)",
    clipPath: "url(#joystick_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1368",
    transform: "rotate(-15.009 26.83 -49.074)",
    d: "M0 0h1.805v1.772H0z",
    fill: "url(#joystick_svg__m)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5872"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5871",
    transform: "translate(0 2)",
    clipPath: "url(#joystick_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8640",
    d: "M-1.337 7.952l10.9 5.27 6.255-7.845-10.9-5.27z",
    fill: "url(#joystick_svg__o)"
  }))))));
};
export default SvgJoystick;